/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Loader } from "../loader/loader";
import Billing from "../billing/billing";
import SubOrganizationBilling from "../billing/sub-organization-billing";
import AddOns from "./add-ons";
import Account from "./account/account-page";
import HighRiskRecommendations from "./high-risk-recommendations";
import OrganizationService from "../../utilities/services/organization-service";
import OrganizationUtil from "../../utilities/organization-util";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { PlanType } from "../../models/enumerations/plan-type";
import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";
import UserUtil from "../../utilities/user-util";
import { useIntercom } from "react-use-intercom";
import Notifications from "./notifications";
import { PageTabs } from "../page-tabs/page-tabs";
import { TabsObject } from "../../models/interfaces/tabs-object";
import { useTranslation } from 'react-i18next';
import { Tabs } from "../../models/enumerations/tabs";
import Integrations from "./integrations";
import { createLogger } from "../../utilities/logger";
// import { Button } from "../button/button";

const COMPONENT_CLASS = "c-settings";

const log = createLogger("Settings");

const Settings: React.FC = () => {

    const params = new URLSearchParams(window.location.search);
    const active = params.get("active");
    const { state } = useAuthState();
    const { t, i18n } = useTranslation();

    const [products, setProducts] = useState<any>();
    const [initialTab, setInitialTab] = useState(active ? Number(active) : Tabs.Account);
    const [tabsArray, setTabsArray] = useState<TabsObject<any>[]>([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
    { tab: Tabs.HighRiskRecommendation, tabLabel: t('settings.tabs.highRiskRecommendations'), component: HighRiskRecommendations }])
    const db = getFirestore();
    // Intercom stuff
    const { boot, shutdown } = useIntercom();
    var CryptoJS = require("crypto-js");

    const switchToJP = () => {
        i18n.changeLanguage('ja');
    }

    useEffect(() => {
        if (state.authenticated) {
            const customAttributes: any = {}
            if (state.user?.roles && state.user.roles.length > 0) {
                customAttributes["Symmio Role"] = state.user.roles[0];
            }
            if (state.organization.plan) {
                customAttributes["Plan Type"] = state.organization.plan.label
            }
            const hmac = generateHmac();
            boot({
                email: state.user?.email,
                userHash: hmac,
                customAttributes: customAttributes,
            })
        }
        else {
            shutdown()
        }
    }, [state.authenticated])

    const generateHmac = () => {

        // Ensure message and secretKey are not empty
        if (!state.user?.email || !process.env.REACT_APP_INTERCOM_VERIFICATION) {
            log.warn("no user or secret key", {
                missing: {
                    email: !state.user?.email,
                    secretKey: !process.env.REACT_APP_INTERCOM_VERIFICATION,
                },
            });
            return;
        }

        // Calculate HMAC using CryptoJS
        const hmac = CryptoJS.HmacSHA256(state.user.email, process.env.REACT_APP_INTERCOM_VERIFICATION).toString();

        return hmac;
    };

    // Get products/prices
    useEffect(() => {
        const getProductsAndPrices = async () => {
            const products: any[] = [];
            // Query to get all active products
            const q = query(
                collection(db, 'products'),
            );
            const querySnapshot = await getDocs(q);
            // Use Promise.all to fetch all prices in parallel
            const productPromises = querySnapshot.docs.map(async (productDoc) => {
                const prices: any[] = [];
                const pricesCollection = collection(productDoc.ref, 'prices');
                const priceQuerySnapshot = await getDocs(pricesCollection);
                priceQuerySnapshot.docs.forEach((item) => {
                    prices.push({ data: item.data(), id: item.id });
                });

                // Combine product data and its prices
                return {
                    product: { data: productDoc.data(), id: productDoc.id },
                    prices: prices,
                };
            });
            // Wait for all productPromises to complete
            Promise.all(productPromises).then((res) => {
                setProducts(res);
            })

            // setIsLoading(false);
        };
        getProductsAndPrices();
    }, [])

    useEffect(() => {
        const setNewTabs = async () => {
            const org = await OrganizationService.get(state.organization.id!);
            const isSubOrg = OrganizationUtil.isSubOrganization(org);

            // Sub-organizations have no subscription of their own; billing shows
            // the limits allocated by the parent organization instead.
            const subOrgBillingTab: TabsObject<any> = { tab: Tabs.Billing, tabLabel: t('settings.tabs.billing'), component: SubOrganizationBilling };

            if (UserUtil.isAccountHolder(state.user) || UserUtil.isSuperAdmin(state.claims)) {
                if (isSubOrg) {
                    setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
                    subOrgBillingTab,
                    { tab: Tabs.HighRiskRecommendation, tabLabel: t('settings.tabs.highRiskRecommendations'), component: HighRiskRecommendations },
                    { tab: Tabs.Notifications, tabLabel: t('settings.tabs.notifications'), component: Notifications },
                    { tab: Tabs.Integrations, tabLabel: t('settings.tabs.integrations'), component: Integrations },
                    ])

                    setInitialTab(Tabs.Account);
                }
                else if (org?.plan?.value === PlanType.Business || org?.plan?.value === PlanType.Core || org?.plan?.value === PlanType.Pro) {
                    setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
                    { tab: Tabs.Billing, tabLabel: t('settings.tabs.billing'), component: Billing, props: { products: products } },
                    { tab: Tabs.AddOns, tabLabel: t('settings.tabs.addOns'), component: AddOns, props: { products: products } },
                    { tab: Tabs.HighRiskRecommendation, tabLabel: t('settings.tabs.highRiskRecommendations'), component: HighRiskRecommendations },
                    { tab: Tabs.Notifications, tabLabel: t('settings.tabs.notifications'), component: Notifications },
                    { tab: Tabs.Integrations, tabLabel: t('settings.tabs.integrations'), component: Integrations },
                    ])
                } else {
                    setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
                    { tab: Tabs.Billing, tabLabel: t('settings.tabs.billing'), component: Billing, props: { products: products } },
                    { tab: Tabs.HighRiskRecommendation, tabLabel: t('settings.tabs.highRiskRecommendations'), component: HighRiskRecommendations },
                    { tab: Tabs.Notifications, tabLabel: t('settings.tabs.notifications'), component: Notifications },
                    { tab: Tabs.Integrations, tabLabel: t('settings.tabs.integrations'), component: Integrations },
                    ])
                }
            }
            else if (UserUtil.isAccountHolder(state.user) || UserUtil.isSuperAdmin(state.claims)) {
                setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
                { tab: Tabs.Billing, tabLabel: t('settings.tabs.billing'), component: Billing, props: { products: products } },
                { tab: Tabs.HighRiskRecommendation, tabLabel: t('settings.tabs.highRiskRecommendations'), component: HighRiskRecommendations },
                { tab: Tabs.Notifications, tabLabel: t('settings.tabs.notifications'), component: Notifications },
                { tab: Tabs.Integrations, tabLabel: t('settings.tabs.integrations'), component: Integrations },
                ])

                setInitialTab(Tabs.Account);
            }
            else if ((UserUtil.isAccountHolder(state.user) || UserUtil.isAdmin(state.user))) {
                if (isSubOrg) {
                    setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
                    subOrgBillingTab,
                    { tab: Tabs.HighRiskRecommendation, tabLabel: t('settings.tabs.highRiskRecommendations'), component: HighRiskRecommendations },
                    { tab: Tabs.Notifications, tabLabel: t('settings.tabs.notifications'), component: Notifications },
                    { tab: Tabs.Integrations, tabLabel: t('settings.tabs.integrations'), component: Integrations },
                    ])
                } else {
                    setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
                    { tab: Tabs.HighRiskRecommendation, tabLabel: t('settings.tabs.highRiskRecommendations'), component: HighRiskRecommendations },
                    { tab: Tabs.Notifications, tabLabel: t('settings.tabs.notifications'), component: Notifications },
                    { tab: Tabs.Integrations, tabLabel: t('settings.tabs.integrations'), component: Integrations },
                    ])
                }

                setInitialTab(Tabs.Account);
            }
            else if ((UserUtil.isAccountHolder(state.user) || UserUtil.isAdmin(state.user) || UserUtil.isManager(state.user))) {
                setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },
                { tab: Tabs.Notifications, tabLabel: t('settings.tabs.notifications'), component: Notifications }])

                setInitialTab(Tabs.Account);
            }
            else {
                setTabsArray([{ tab: Tabs.Account, tabLabel: t('settings.tabs.account'), component: Account },])

                setInitialTab(Tabs.Account);
            }
        }
        setNewTabs()
    }, [state.organization.id, products])

    return (
        <>
            <div className={COMPONENT_CLASS}>
                <div className={`${COMPONENT_CLASS}__header`}>
                    <h1>{t('settings.title')}</h1>
                </div>
                <PageTabs components={tabsArray} initialTab={initialTab} />
            </div>
        </>

    );

}

export default Settings;